/**
 * Was der SMS-Anbieter als Absender akzeptiert.
 *
 * Dieselbe Regel wie im Backend (``app/services/sms_service.py``): entweder eine
 * Rufnummer oder höchstens elf Zeichen aus Buchstaben, Ziffern und Leerzeichen.
 *
 * Auf dem Testsystem stand hier „FIT IN music" — zwölf Zeichen. Das Feld nahm es
 * an, der Hinweis darunter war reine Zierde, und jede SMS scheiterte danach
 * beim Anbieter (T-0020).
 */
export const SMS_ABSENDER_MAX = 11;

export function smsAbsenderFehler(wert: string): string {
  const absender = (wert || '').trim();
  if (absender === '') return '';
  const rumpf = absender.startsWith('+') ? absender.slice(1) : absender;
  if (/^\d{1,16}$/.test(rumpf)) return '';
  if (new RegExp(`^[A-Za-z0-9 ]{1,${SMS_ABSENDER_MAX}}$`).test(absender)) return '';
  return `Der Anbieter nimmt höchstens ${SMS_ABSENDER_MAX} Zeichen aus Buchstaben, Ziffern und Leerzeichen — oder eine Rufnummer.`;
}

/** Die nächstliegende zulässige Schreibweise; leer, wenn nichts übrig bleibt. */
export function smsAbsenderVorschlag(wert: string): string {
  const absender = (wert || '').trim();
  if (absender === '' || smsAbsenderFehler(absender) === '') return '';
  let gesaeubert = absender.replace(/[^A-Za-z0-9 ]/g, '').trim();
  if (gesaeubert.length > SMS_ABSENDER_MAX) {
    gesaeubert = gesaeubert.replace(/ /g, '').slice(0, SMS_ABSENDER_MAX);
  }
  return gesaeubert;
}
